import React from "react";
import InfoCard from "../../components/InfoCard/InfoCard";
import "./Details.css";

const Details: React.FC = () => {
  const handleChangePassword = () => {
    console.log("Change Password for Account Details");
  };

  const handleChangePaymentMethod = () => {
    console.log("Change Address for Billing Address");
  };

  return (
    <div className="dashboard-cards-container">
      <InfoCard
        title="Account Details"
        details={[
          { label: "Name", value: "Jasjeet Singh" },
          { label: "Display Name", value: "Jasjeet@8978" },
          { label: "Email Address", value: "jasjeet3@gmail.com" },
          { label: "Phone", value: "(604) 678-90897" },
          { label: "Birthday", value: "1/1/1989" },
        ]}
        onChangePassword={handleChangePassword}
        linkText="Change Password"
        onEdit={() => console.log("Edit Account Details")}
        borderColor="#894395"
      />
      <InfoCard
        title="Billing Address"
        details={[
          { label: "Name", value: "Jasjeet Singh" },
          { label: "Display Name", value: "Jasjeet@8978" },
          { label: "Email Address", value: "jasjeet3@gmail.com" },
          { label: "Company", value: "Add Billing company" },
          { label: "Address", value: "38 rockdale drive amherst, Ny 14228" },
        ]}
        onChangePassword={handleChangePaymentMethod}
        linkText="View/Change payment methods"
        onEdit={() => console.log("Edit Billing Address")}
        borderColor="#D5E8F0"
      />
      <InfoCard
        title="Shipping Address"
        details={[
          { label: "Name", value: "Add Shipping Name" },
          { label: "Phone", value: "Add Phone Number" },
          { label: "Company", value: "Add Shipping Company" },
          { label: "Address", value: "Add Shipping Address" },
        ]}
        onEdit={() => console.log("Edit Shipping Address")}
        borderColor="#1369B6"
      />
    </div>
  );
};

export default Details;
